import { BOOKLET_SET_ARCHIVED_SUCCESS } from './booklet.reducer';

export const BOOKLET_LIST_FETCH = 'BOOKLET_LIST/FETCH';
export const BOOKLET_LIST_FETCH_SUCCESS = 'BOOKLET_LIST/FETCH_SUCCESS';
export const BOOKLET_LIST_FETCH_FAILURE = 'BOOKLET_LIST/FETCH_FAILURE';

const initialState = {
  list: [],
};

export const fetchBookletList = () => ({
  type: BOOKLET_LIST_FETCH,
});

export const bookletListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOOKLET_LIST_FETCH_SUCCESS: {
      return { list: [...payload] };
    }
    case BOOKLET_LIST_FETCH_FAILURE: {
      return state;
    }
    case BOOKLET_SET_ARCHIVED_SUCCESS: {
      const { isArchived, index } = payload;
      const list = isArchived
        ? [...state.list.slice(0, index), ...state.list.slice(index + 1)]
        : state;
      return { list };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/booklet-list.reducer.js